import { gql } from 'graphql-tag';

export default gql`
  query GetUserPrefsNotificationPrefs(
    $orderNumber: String!
    $retailerMoniker: String!
  ) {
    getUserPrefsNotificationPreferences(
      orderNumber: $orderNumber
      retailerMoniker: $retailerMoniker
    ) {
      optIns {
        level
        preferences {
          status
        }
      }
    }
  }
`;
